import script from "./form.vue?vue&type=script&lang=jsx"
export * from "./form.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__